/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type OrderRequestDto = {
    /**
     * ID двигателя
     */
    engineId: number;
    /**
     * Тип работы
     */
    workType: OrderRequestDto.workType;
    /**
     * UUID отчета
     */
    reportFileUuids?: Array<string>;
    /**
     * Комментарий
     */
    comment?: string;
    /**
     * Статус заказа
     */
    status: OrderRequestDto.status;
};

export namespace OrderRequestDto {

    /**
     * Тип работы
     */
    export enum workType {
        MAINTENANCE = 'MAINTENANCE',
        REPAIR = 'REPAIR',
        INSPECTION = 'INSPECTION',
        UPGRADE = 'UPGRADE',
        REPLACEMENT = 'REPLACEMENT',
        CALIBRATION = 'CALIBRATION',
    }

    /**
     * Статус заказа
     */
    export enum status {
        NEW = 'NEW',
        IN_PROGRESS = 'IN_PROGRESS',
        COMPLETED = 'COMPLETED',
        CANCELLED = 'CANCELLED',
    }


}

